import { Icon } from '../components/Icon';
import { ProductCard } from '../components/ProductCard';
import { Seo } from '../components/Seo';
import { siteConfig } from '../config/site';

export function PluginsPage() {
  return (
    <>
      <Seo title="Emberline" description="Discover Emberline, Wavecraft's expressive signal-shaping instrument for macOS." path="/plugins" />
      <section className="page-hero page-hero--plugins section--grain">
        <div className="shell page-hero__grid">
          <div><span className="eyebrow eyebrow--line">Wavecraft instruments</span><h1>One focused instrument. A wide creative range.</h1></div>
          <div className="page-hero__aside">
            <p>Emberline turns a coordinated signal path into one playable decision, with the controls needed to keep that decision mix-ready.</p>
            <div className="platform-chips">{siteConfig.compatibility.formats.map((format) => <span key={format}>{format}</span>)}</div>
          </div>
        </div>
      </section>

      <section className="section catalog-section">
        <div className="shell">
          <div className="catalog-toolbar"><span>Emberline 1.0.0</span><span>Perpetual license · 10-day trial · Three computers</span></div>
          <div className="product-grid product-grid--catalog product-grid--single">
            {siteConfig.products.map((product) => <ProductCard key={product.slug} product={product} featured />)}
          </div>
        </div>
      </section>

      <section className="section compatibility-section">
        <div className="shell compatibility-section__grid">
          <div><span className="eyebrow">Compatibility</span><h2>{siteConfig.compatibility.headline}</h2></div>
          <div className="compatibility-list">{siteConfig.compatibility.details.map((detail) => <span key={detail}><Icon name="check" />{detail}</span>)}</div>
          <p className="fine-print">{siteConfig.compatibility.note}</p>
        </div>
      </section>
    </>
  );
}
